import carCrash from 'static/img/icons/car_crash.svg';
import carOnFire from 'static/img/icons/car_on_fire.svg';
import LandingSection from 'components/landing/components/landing-section';
import TextBox from 'core/text-box';
import useGetSeoTextByIndex from 'hooks/useGetSeoTextByIndex';

const InsuranceConcept = () => {
    const { seoText, verification } = useGetSeoTextByIndex('concept');

    if (!verification) {
        return null;
    }

    return (
        <LandingSection>
            <div className="paragraph_wrapper" style={{ marginBottom: '40px' }}>
                <TextBox
                    title={seoText.paragraph1.title}
                    content={seoText.paragraph1.sentence1}
                    image={carOnFire}
                />
                <TextBox
                    title={seoText.paragraph2.title}
                    content={seoText.paragraph2.sentence1}
                    image={carCrash}
                />
            </div>
        </LandingSection>
    );
};

export default InsuranceConcept;
